import React from "react";
import {
  Accordion as MUIAccordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Paper,
  Grid
} from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
import { ArrowForwardIosSharp } from "@mui/icons-material";
import PropTypes from "prop-types";

Accordion.propTypes = {
  item: PropTypes.object.isRequired,
  error: PropTypes.string,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
  renderFields: PropTypes.func,
};

export default function Accordion(props) {
  const { item, error = null, renderFields } = props;

  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderStyle: "solid",
        borderWidth: error ? "2px" : "1px",
        borderColor: error ? "#FF000060" : "#E6E6E6",
        borderRadius: "4px",
      }}
    >
      <MUIAccordion
        disableGutters
        elevation={0}
        expanded={expanded === item.name}
        onChange={handleChange(item.name)}
        sx={{
          borderRadius: "4px",
        }}
      >
        <AccordionSummary
          id="{item.name}-header"
          expandIcon={<ArrowForwardIosSharp sx={{ fontSize: "12px" }} />}
          sx={{
            backgroundColor: "#E6E6E6",
            flexDirection: "row-reverse",
            "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
              transform: "rotate(90deg)",
            },
            ":hover": {
              backgroundColor: "clickableHover",
              cursor: "pointer",
            },
          }}
        >
          <Typography
            variant="regular_text_14px_normal"
            sx={{
              marginLeft: "20px",
            }}
          >
            {item.label}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container="true" spacing={2}>
            {renderFields(item.children)}
          </Grid>
        </AccordionDetails>
      </MUIAccordion>
    </Paper>
  );
}
